<script setup lang="ts">
  import BaseModal from './BaseModal.vue'

  defineProps<{
    message: string
  }>()

  const emit = defineEmits<{
    confirm: []
  }>()

  const show = defineModel<boolean>('show', { default: false })

  const { t } = useI18n()

  const handleConfirm = () => {
    show.value = false
    emit('confirm')
  }
</script>

<template>
  <BaseModal
    v-model:show="show"
    confirm-label="base_yes"
    cancel-label="base_no"
    header-class=""
    body-class="pl-7 pt-2 pb-6"
    :confirm-button-props="{
      type: 'error',
      strong: true,
    }"
    :show-close-button="false"
    :cancel-button-props="{
      secondary: true,
      strong: true,
    }"
    @confirm="handleConfirm"
    @cancel="show = false"
  >
    <template #header>
      <div class="flex flex-nowrap! items-center gap-2">
        <i
          class="fa-solid fa-exclamation-circle text-error text-[18px]"
          aria-hidden="true"
        />
        <div class="heading-md grow">{{ $t('base_cancel') }}?</div>
        <NButton
          text
          :aria-label="t('base_close')"
          @click="show = false"
        >
          <i
            class="fa-solid fa-xmark text-base text-(--color-icon-placeholder)"
            aria-hidden="true"
          />
        </NButton>
      </div>
    </template>
    <template #body>
      <div class="body-lg">{{ $t(message) }}</div>
    </template>
  </BaseModal>
</template>
